import { useEffect, useState } from 'react';
import { loadSignatureImageUrl } from './signatures';

/**
 * Adresse de l'image dessinée d'une signature, chargée au montage (deux requêtes : son fichier, puis son adresse
 * temporaire, valable 5 minutes : redemandée à chaque montage). url null : pas d'image (signature d'avant l'image, ou
 * lecture refusée), ou chargement en cours (loading).
 */
export function useSignatureImageUrl(signatureUrn: string): { url: string | null; loading: boolean } {
  const [state, setState] = useState<{ urn: string; url: string | null } | null>(null);

  useEffect(() => {
    let active = true;
    loadSignatureImageUrl(signatureUrn)
      .then((url) => active && setState({ urn: signatureUrn, url }))
      .catch(() => active && setState({ urn: signatureUrn, url: null }));

    return () => {
      active = false;
    };
  }, [signatureUrn]);

  const loaded = state?.urn === signatureUrn;
  return { url: loaded ? state.url : null, loading: !loaded };
}
